module.exports = __webpack_public_path__ + "static/media/1007019.aaeb7e3c.jpg";